import { DateTime } from 'luxon';
import { DatePickerRepeatTrans, TimePickerRepeatTrans } from '../../../../../../Elements/DatePicker/utils/constants';
import { sameDate } from './sameDate';
// User readable date range.
export var pickerRangeToString = function (values, others) {
    var _a, _b;
    if (values === void 0) { values = []; }
    if (((_a = others === null || others === void 0 ? void 0 : others[0]) === null || _a === void 0 ? void 0 : _a.dateTypeRepeater) || ((_b = others === null || others === void 0 ? void 0 : others[1]) === null || _b === void 0 ? void 0 : _b.dateTypeRepeater)) {
        return others
            .map(function (other, i) {
            if (!(other === null || other === void 0 ? void 0 : other.dateTypeRepeater)) {
                return values[i] && DateTime.fromJSDate(values[i]).toFormat('dd.LL.yyyy HH:mm');
            }
            var repeaterDate = DatePickerRepeatTrans[other === null || other === void 0 ? void 0 : other.dateTypeRepeater];
            var repeaterTime = i === 0 ? TimePickerRepeatTrans.from : TimePickerRepeatTrans.to;
            var time = (other === null || other === void 0 ? void 0 : other.time) ? "".concat(String(other === null || other === void 0 ? void 0 : other.time.h).padStart(2, '0'), ":").concat(String(other === null || other === void 0 ? void 0 : other.time.m).padStart(2, '0')) : '';
            return "".concat(repeaterTime, " ").concat(repeaterDate, " ").concat(time).trim();
        })
            .filter(Boolean)
            .join(' - ');
    }
    // If no date is specified
    if (!values[0] && !values[1]) {
        return '';
    }
    // If only From date is specified or if both of date are same, show only one date
    if ((values[0] && !values[1]) || sameDate(values[0], values[1])) {
        return DateTime.fromJSDate(values[0]).toFormat('dd.LL.yyyy');
    }
    // Format each date separately and join together
    return values.map(function (v) { return v && DateTime.fromJSDate(v).toFormat('dd.LL.yyyy HH:mm'); }).join(' - ');
};
